import React, { useEffect, useState } from 'react'
import TopBar from '../component/TopBar'
import MenuBar from '../component/MenuBar'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import Footer from '../component/Footer'
import { Col, Row, Container } from 'react-bootstrap'
import OtherService from '../services/Other'
import PrimaryGradientButton from '../component/PrimaryGradientButton';
import { Link, useNavigate } from 'react-router-dom'
import Header from '../component/Header'
import Loader from '../component/Loader'

const VideoGallery = () => {
  //All UseState
 const [loading, setLoading] = useState(true);
 const [isVideoGallery, setIsVideoGallery] = useState([]);
 const [noData, setNoData] = useState(false);
 //UseEffect
 useEffect(()=>{
    const videoDataFetch = async()=>{
      try {
        const token = localStorage.getItem('access_token');
        const videoDataResponse = await OtherService.gallery(token);
        if(videoDataResponse.error == false)
        { 
          if(videoDataResponse.data.videoDetails.length > 0)
          {
            setIsVideoGallery(videoDataResponse.data.videoDetails);
            setLoading(false)
            setNoData(false)
          }
          else{
            setLoading(false)
            setNoData(true)
          }
          
        }
        else{
          setLoading(false)
          setNoData(true)
        }
      }
      catch (error) {
        console.error('Error:');
      }
    }
    videoDataFetch()
 },[])
 const navigate = useNavigate()
 //All Functions
 const handleVidItemDetails = (contentId) => {
   navigate(`/video-gallery/${contentId}`);
}
  return (
    <> 
      {/* {loading && <Loader/>} */}
      
      <BreadCrumbSecttion
        pageTitle="Gallery"
        currentPageName="Gallery"
      />
      <section className='padTop50'>
        <Container>
          <Row>
            <Col xs={12}>
              <div className='notificationTabList'>
                <ul>
                  <li>
                    <Link to="/gallery">Photo</Link>
                  </li>
                  <li className='active'>
                    <Link to="/video-gallery">Video</Link>
                  </li>
                  <li>
                    <Link to="/document-gallery">Document</Link>
                  </li>
                </ul>
              </div>
              <div className='userInfoBox'>
               
                  <div className="dashboard-details">
                  {noData && 
                    <Row>
                      <Col><div className="noDataMsg">No data found!</div></Col>
                    </Row>
                     }
                    <Row>

                      {isVideoGallery?.map((item) => {
                        const { contentDetails, files, index } = item;
                        return (
                          <Col xs={12} lg={3} key={contentDetails.id} className='galleryImgBox'>
                            <div className='itemWrap'>
                              <div className='itemWrapImage'>
                                
                              {files.length > 0 && (
                                  <img src={files[0].thumbnail_image} className='img-fluid'/>
                                )}
                                                    
                              </div>
                              <div className="itemWrapImageTxt"><p>{contentDetails.title}</p></div>
                              <PrimaryGradientButton buttonText="View More"  onClick={()=>handleVidItemDetails(contentDetails.id)}/>
                             </div>
                          </Col>
                        );
                      })}
                    </Row>
                     
                  

                  </div>
            
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      

    </>
  )
}

export default VideoGallery